import React from "react";
import { Button } from "semantic-ui-react";
import SegmentEdit from "../components/SegmentEdit";
import { type ModifySegmentInstruction, segmentToInstruction } from "../utils";

interface Props {
  segmentToEdit: server.dto.TrainSegment
  train: server.dto.Train
  onFinished: (newTrain: server.dto.Train) => void
}

const ExistingTrainSegmentEditScreen = (props: Props) => {
  const { segmentToEdit } = props;
  const [segment, setSegment] = React.useState<ModifySegmentInstruction>(segmentToInstruction(segmentToEdit));
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [startStationEmpty, setStartStationEmpty] = React.useState<boolean>(false);
  const [endStationEmpty, setEndStationEmpty] = React.useState<boolean>(false);

  const onSave = async () => {
    if (isLoading) {
      return;
    }

    const noStartStation = segment.startStationId == null;
    const noEndStation = segment.endStationId == null;
    setStartStationEmpty(noStartStation);
    setEndStationEmpty(noEndStation);

    if (noStartStation || noEndStation) {
      return;
    }

    setIsLoading(true);

    // const result = await window.Api.Trains.UpdateSegment(props.segmentToEdit.id, segment);
    let result;
    if (props.segmentToEdit.id) {
      result = await window.Api.Trains.UpdateSegment(props.segmentToEdit.id, segment);
    } else {
      result = await window.Api.Trains.CreateSegment(props.train.id, segment);
    }

    props.onFinished(result.data);
  };

  return <>
    <div className="grow1 scrollbox-auto s1_panel">
      <SegmentEdit
        segment={segment}
        onSegmentChange={setSegment}
        startStationEmpty={startStationEmpty}
        endStationEmpty={endStationEmpty}
      />
    </div>

    <div className="flex margin-top justify-end margin-right">
      <div>
        <Button loading={isLoading} primary onClick={onSave}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </>;
};

export default ExistingTrainSegmentEditScreen;